function PageScrollController(){
    this.glob = "/**";
    this.log = false;


	/* Settings */


	this.overOpacity 		= 0;
	this.extraOverOpacity 	= 0;
	this.tranisionMs 		= 1000; //This is actually set in the css (easier to ensure browser variations)
	this.changeOverDelay	= 500;
	this.changeOfffDelay	= 0;
};
PageScrollController.inheritsFrom( StandardController );
PageScrollController.prototype.on = function(){
    this.$body = $("body");

    this.showLogoFirstTime = true;
    this.logoAnimationDuration = 300;

    // console.log('%c[PageScrollController]', 'color:orange')
    
    // The smooth scroll effect relies on the GSAP library (scripts loaded in the footer)
    // <script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.5.1/gsap.min.js"></script>
    // <script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.5.1/ScrollTrigger.min.js"></script>
    
    /*
    this.$container = this.$body.find(".page-scroll-scrollable");
    if(!this.$container.length) return;

    console.log(this.$container);
    
    const setHeight = () => {
        this.height = this.$container[0].clientHeight;
        this.$body.css({height: `${this.height}px`});
    }

    gsap.registerPlugin(ScrollTrigger);
    
    // ScrollTrigger.addEventListener("refreshInit", setHeight);
    // ScrollTrigger.addEventListener("scrollEnd", setHeight);

    // // smooth scrolling container
    // gsap.to(this.container, {
    //     y: () => -(this.height - document.documentElement.clientHeight),
    //     ease: "none",
    //     scrollTrigger: {
    //         trigger: document.body,
    //         start: "top top",
    //         end: "bottom bottom",
    //         scrub: 1,
    //         invalidateOnRefresh: true,
    //     }
    // });

    */




	const isHome = document.querySelector('.body-home');

	let logo;
	if (isHome) {
		logo = document.querySelector('.intro .page-logo');
	} else {
		logo = document.querySelector('.page-logo');
	}

	const logoTop = logo.querySelector('.logo-top');
	const logoBottom = logo.querySelector('.logo-bottom');

	this.isHome = isHome;
	this.logo = logo;
	this.logoTop = logoTop;
	this.logoBottom = logoBottom;

	this.logoPath = this.logoTop.querySelector('path');
	this.logoColour = this.logoPath.getAttribute('fill');
	this.menuButton = document.querySelector('.js-page-menu-button');
	this.logoColourReplacements = [
		{ key: 'rgb(64, 82, 107)', value: '#c4c4c4' },
		{ key: 'rgb(247, 247, 247)', value: '#40526B' },
		{ key: 'rgb(230, 230, 230)', value: '#2c394c' },
		{ key: 'rgb(246, 246, 246)', value: '#40526B' },
		{ key: 'rgb(255, 255, 255)', value: '#40526B' },
	];

	const resize = () => {
		this.isDesktop = $(window).innerWidth() >= 1000;
		this.innerHeight = $(window).innerHeight();
	};
	resize();


	this.setOpacityInstant(1);
	this.setupSectionsAndElements();

	this.lastScrollTop = document.documentElement.scrollTop;
    this.scrollDelegate = () => {
		this.currentScrollTop = document.documentElement.scrollTop;
		this.lastScrolledDown = this.currentScrollTop > this.lastScrollTop;
		this.setPageLogoPosition();
		this.lastScrollTop = this.currentScrollTop <= 0 ? 0 : this.currentScrollTop;
	}
	document.addEventListener("scroll", this.scrollDelegate);


    window.onresize = () => {
		resize();
		this.setPageLogoPosition();
	}
    this.setPageLogoPosition();
};
PageScrollController.prototype.off = function(){
	if(this.timeout) clearTimeout(this.timeout);
	if(this.scrollDelegate) document.removeEventListener("scroll", this.scrollDelegate);
};
PageScrollController.prototype.getLogoColour = function(colour) {
	const colourObject = this.logoColourReplacements.find(obj => obj.key === colour);
	return colourObject ? colourObject.value : null;
}
PageScrollController.prototype.setPageLogoPosition = function() {
	// console.log('scrolling?');
    if (this.log) console.log(`%c[PageSCrollController]`, 'background:darksalmon', `setPageLogoPosition`);

	const isHome = this.isHome;

    // Identify logo and its parts.
	const logo = this.logo;
    const logoTop = this.logoTop;
    const logoBottom = this.logoBottom;


    
    let fixedPositionY = 30;
    let triggerPositionY = 30;
    
    const isDesktop = this.isDesktop;
    if(isDesktop) {
        fixedPositionY = 100;
        triggerPositionY = this.innerHeight / 2 - fixedPositionY;
    }

    let triggerHidePositionY = this.innerHeight /10;
    if (isHome) {
        triggerHidePositionY = triggerPositionY;
    }
    
    const scrollPositionY = $(window).scrollTop();
    const isLogoFixed = scrollPositionY > triggerPositionY;    

    const shouldHideLogo = scrollPositionY > triggerHidePositionY;
    if (shouldHideLogo) {
        let timeToRemove = 0;
        if (!this.showLogoFirstTime) {
            timeToRemove = this.logoAnimationDuration;
        }
        $(logoBottom).fadeOut(timeToRemove);
        this.showLogoFirstTime = false;
    } else {
        $(logoBottom).fadeIn(this.logoAnimationDuration);
    }
    this.showLogoFirstTime = false;



    // console.log(scrollPositionY, triggerPositionY);

    // Pin the logo when it reaches the top position after scrolling
    if (isLogoFixed) {

        // Set logo fixed position.
        logo.style.top = isDesktop ? `${fixedPositionY - 61}px` : `${fixedPositionY}px`;

    }else{

        // Calculate dynamic position for moving logo in the homepage.
        if (isHome) {

            // Set logo custom position.
            logo.style.top = isDesktop ? `calc(50% - ${scrollPositionY + 65}px)` : `30px`;

        } else {

            logo.style.top = isDesktop ? `39px` : `30px`;

        }

    }



    //Check if the logo top is clashing with any elements on the page
    //Clean up after

	// as soon as we scroll we start to show the logo
	this.setOpacityInstant(1);

    const logoBounds = logoTop.getBoundingClientRect();
    const lt = logoBounds.top;
    const lb = logoBounds.bottom;
	const ll = logoBounds.left;
	const lr = logoBounds.right;
	const lm = (lt + lb) / 2;


	//Check through the sections first
    const $sections = document.querySelectorAll("body section");
    const elementSets = [];
	const sectionSets = [];
	this.sections.forEach(s => {

        const bounds    = s.section.getBoundingClientRect();
        const st        = bounds.top;
        const sb        = bounds.bottom;

        if(lb > st && lt < sb) elementSets.push(s.elements);

		// for colour detection - not picking up footer
		sectionSets.push(s.section);
    })

	// Change logo/menu colour based on section theme.
	const themeSections = document.querySelectorAll('.js-body [class*="theme-"], body[class*="theme-"]');
	themeSections.forEach((elm, index) => {

		const bounds    = elm.getBoundingClientRect();
		const et        = bounds.top;
		const eb        = bounds.bottom;

		if((this.lastScrolledDown && lm > et && lt < eb) || !this.lastScrolledDown && lt > et && lt < eb) {
			const elmParentColour = window.getComputedStyle(elm, null).backgroundColor;
			const logoColour = this.getLogoColour(elmParentColour);
			this.logoPath.style.fill = logoColour;
			this.menuButton.style.color = logoColour;
		}
	});

	// console.log(sectionSets, ' s.section.getBoundingClientRect()');

	const p = 10; //padding

    let overlap = false;

	for(let i = 0; i < elementSets.length; i++){
		for(let j = 0; j < elementSets[i].length; j++){

			const element	= elementSets[i][j];
			const elm		= element.element;

			if(elm.closest(".backgrounded") !== null) continue;

			const pt		= parseFloat(window.getComputedStyle(elm, null).getPropertyValue('padding-top'));
			const pb		= parseFloat(window.getComputedStyle(elm, null).getPropertyValue('padding-bottom'));

			const bounds    = elm.getBoundingClientRect();
			const et        = bounds.top + pt;
			const eb        = bounds.bottom - pb;
			const el        = bounds.left;
			const er        = bounds.right;

			//Overlaps
			if(lb + p > et && lt < eb + p && lr + p > el && ll < er + p){
				overlap = element.opacity;
			}

			if(overlap !== false) break;
		}
		if(overlap !== false) break;
	}

	if(overlap !== false){
		//this.setOpacity(overlap === false ? 1 : overlap);
		this.setOpacity(overlap);
	}
}
PageScrollController.prototype.setupSectionsAndElements = function() {

	const final = [];



	const types = "h1,h2,h3,h4,p,img,.concept-letter-inner,.img-replace, div > a";
	const extraTypes = ".team-member .img-replace";

	const sections = document.querySelectorAll("body section");
	sections.forEach(section => {
		const elements = Array.from(section.querySelectorAll(types));
		const extraElements = Array.from(section.querySelectorAll(extraTypes));
		const combined = extraElements
							.map( e => ({element: e, opacity: this.extraOverOpacity}) )
							.concat(...elements.map( e => ({element: e, opacity: this.overOpacity}) ))

		final.push({
			section,
			elements: combined
		});
	});

	this.sections = final;
	// console.log(this.sections, ' this.sections');

}
PageScrollController.prototype.setOpacityInstant = function( opacity  ) {
	if(this.opacity !== opacity){
		this.logoTop.style.opacity = opacity;
		this.opacity = opacity;
	}

	this.waitingOpacity = false;
	// console.log("Boom, set to " + opacity)
}
PageScrollController.prototype.setOpacity = function( opacity ) {

	//console.log("S " + opacity)

	// we're adding a delay
	// if nothing else is waiting and it's a new value then start the delay
	// or if we're already waiting, check that it's different to the waiting value
	if((this.waitingOpacity === false && opacity !== this.opacity) || (this.waitingOpacity !== false && opacity !== this.waitingOpacity)){
		//console.log("Set it to opaciy " + opacity)

		if(this.timeout) clearTimeout(this.timeout);

		this.waitingOpacity = opacity;
		const delay = opacity < 1 ? this.changeOverDelay : this.changeOffDelay;
		this.timeout = setTimeout(() => {
			this.setOpacityInstant(this.waitingOpacity);
		},delay);
	}

}
